import { TextBlock } from 'types';
import { MomentService } from '../../services/moment.service';
import numeral from 'numeral';

export class Helper {
  /**Fix all rows with either debit/credit/blance columns got combined*/
  static splitCombinedColumns (transactionDetails) {
    let fixApplied = false;
    for (let i = 0; i < transactionDetails.length; i++) {
      const uniqueRowIndex = [
        ...new Set(
          transactionDetails[i].cells.map((item) => item.rowIndex)),
      ];

      let lastColumnMedians = [];
      let rowsNeedFixing = [];
      for (let j = 0; j < uniqueRowIndex.length; j++) {
        const targetRow = transactionDetails[i].cells.filter((cell) => {
          if (cell.rowIndex === uniqueRowIndex[j]) {
            return cell;
          }
        });

        if (targetRow.length < 5 && targetRow[targetRow.length - 1].line && targetRow[targetRow.length - 1].line.match(/[$]/g) && (targetRow[targetRow.length - 1].line.match(/[$]/g)).length > 1) {
          rowsNeedFixing.push(targetRow);
          if (targetRow[targetRow.length - 1].words.length === 2) {
            const lastCol = targetRow[targetRow.length - 1];
            lastColumnMedians.push(lastCol.wordsAnnotationArray
              [1].boundingPoly.vertices[0].x + lastCol.wordsAnnotationArray
              [0].boundingPoly.vertices[1].x) / 2;
          }
        } else if (targetRow.length < 5 && targetRow[targetRow.length - 1].line && targetRow[targetRow.length - 1].line.match(/[$]/g) && (targetRow[targetRow.length - 1].line.match(/[$]/g)).length === 1
        && ((targetRow[targetRow.length - 1].wordsAnnotationArray[0].boundingPoly.vertices[0].x - targetRow[targetRow.length - 1].boundingPoly.vertices[0].x) > 60)) {
          rowsNeedFixing.push(targetRow);
        } else if (targetRow.length < 5 && targetRow[targetRow.length - 1].line && targetRow[targetRow.length - 1].line.match(/[$]/g) && (targetRow[targetRow.length - 1].line.match(/[$]/g)).length === 2 && targetRow[targetRow.length - 1].wordsAnnotationArray.length === 1) {
          rowsNeedFixing.push(targetRow);
        }
      }

      lastColumnMedians.sort();

      if (rowsNeedFixing.length > 0) {
        console.log('splitCombinedColumns');
        fixApplied = true;
      }

      for (let k = 0; k < rowsNeedFixing.length; k++) {
        const lastCol = rowsNeedFixing[k][rowsNeedFixing[k].length - 1]; // initial
        const wordsAnnotationArray = lastCol.wordsAnnotationArray;
        if (wordsAnnotationArray.length === 2 && wordsAnnotationArray[0].description && wordsAnnotationArray[0].description.match(/[$]\d/)
        && wordsAnnotationArray[1].description && wordsAnnotationArray[1].description.match(/[$]\d/)) {
          const secondLastColumn = lastCol;
          const lastColumn = deepCopy(lastCol);

          secondLastColumn.wordsAnnotationArray = [lastCol.wordsAnnotationArray[0]];
          secondLastColumn.words = [lastCol.words[0]];
          secondLastColumn.line = lastCol.words[0];
          secondLastColumn.boundingPoly.vertices[1].x = lastCol.wordsAnnotationArray[0].boundingPoly.vertices[1].x;
          secondLastColumn.boundingPoly.vertices[2].x = lastCol.wordsAnnotationArray[0].boundingPoly.vertices[2].x;

          lastColumn.id = lastColumn.id + '-1';
          lastColumn.columnIndex = lastColumn.columnIndex + 1;
          lastColumn.wordsAnnotationArray = [lastColumn.wordsAnnotationArray[1]];
          lastColumn.words = [lastColumn.words[1]];
          lastColumn.line = lastColumn.words[0].toString();
          lastColumn.boundingPoly.vertices[0].x = secondLastColumn.boundingPoly.vertices[1].x;
          lastColumn.boundingPoly.vertices[3].x = secondLastColumn.boundingPoly.vertices[2].x;

          transactionDetails[i].cells.filter((item, index) => {
            if (item.id === lastCol.id) {
              transactionDetails[i].cells[index] = secondLastColumn;
              transactionDetails[i].cells.splice(index + 1, 0, lastColumn);
            }
          });

        } else if (wordsAnnotationArray.length === 1 && lastCol.line.match(/[$]/g).length === 1) {
          const secondLastColumn = lastCol;
          const lastColumn = deepCopy(lastCol);

          secondLastColumn.boundingPoly.vertices[1].x = wordsAnnotationArray[0].boundingPoly.vertices[0].x;
          secondLastColumn.boundingPoly.vertices[2].x = wordsAnnotationArray[0].boundingPoly.vertices[3].x;
          secondLastColumn.wordsAnnotationArray = [];
          secondLastColumn.words = [];
          secondLastColumn.line = '';

          lastColumn.id = lastColumn.id + '-1';
          lastColumn.columnIndex = lastColumn.columnIndex + 1;
          lastColumn.wordsAnnotationArray = [lastColumn.wordsAnnotationArray[0]];
          lastColumn.words = [lastColumn.words[0]];
          lastColumn.line = lastColumn.words[0].toString();
          lastColumn.boundingPoly.vertices[0].x = secondLastColumn.boundingPoly.vertices[1].x;
          lastColumn.boundingPoly.vertices[3].x = secondLastColumn.boundingPoly.vertices[2].x;

          transactionDetails[i].cells.filter((item, index) => {
            if (item.id === secondLastColumn.id) {
              transactionDetails[i].cells[index] = secondLastColumn;
              transactionDetails[i].cells.splice(index + 1, 0, lastColumn);
            }
          });
        } else if (wordsAnnotationArray.length === 1 && lastCol.line.match(/[$]/g).length === 2) {
          const textLine = lastCol.line.replace(/[.]/g, '').replace(/[,]/g, '').trim();
          const secondLastColumn = lastCol;
          const emptyColumn = deepCopy(lastCol);
          const lastColumn = deepCopy(lastCol);
          const words = [lastCol.line.substring(0, lastCol.line.lastIndexOf('$')), lastCol.line.substring(lastCol.line.lastIndexOf('$'), lastCol.line.length)];
          const charWidth = (wordsAnnotationArray[0].boundingPoly.vertices[1].x - wordsAnnotationArray[0].boundingPoly.vertices[0].x) / textLine.length;
          let addEmptyColumn = false;
          if (rowsNeedFixing[k].length < 4) {
            addEmptyColumn = true;
            secondLastColumn.boundingPoly.vertices[0].x = wordsAnnotationArray[0].boundingPoly.vertices[0].x;
            secondLastColumn.boundingPoly.vertices[3].x = wordsAnnotationArray[0].boundingPoly.vertices[3].x;
            emptyColumn.boundingPoly.vertices[0].x = rowsNeedFixing[k][rowsNeedFixing[k].length - 2].boundingPoly.vertices[1].x;
            emptyColumn.boundingPoly.vertices[3].x = rowsNeedFixing[k][rowsNeedFixing[k].length - 2].boundingPoly.vertices[2].x;
          }
          secondLastColumn.boundingPoly.vertices[1].x = wordsAnnotationArray[0].boundingPoly.vertices[0].x + (words[0].length * charWidth);
          secondLastColumn.boundingPoly.vertices[2].x = wordsAnnotationArray[0].boundingPoly.vertices[3].x + (words[0].length * charWidth);
          secondLastColumn.wordsAnnotationArray = lastCol.wordsAnnotationArray;
          secondLastColumn.wordsAnnotationArray[0].description = words[0];
          secondLastColumn.wordsAnnotationArray[0].boundingPoly.vertices[0].x = lastCol.boundingPoly.vertices[0].x;
          secondLastColumn.wordsAnnotationArray[0].boundingPoly.vertices[1].x = lastCol.boundingPoly.vertices[0].x + (words[0].length * charWidth);
          secondLastColumn.wordsAnnotationArray[0].boundingPoly.vertices[2].x = lastCol.boundingPoly.vertices[3].x + (words[0].length * charWidth);
          secondLastColumn.wordsAnnotationArray[0].boundingPoly.vertices[3].x = lastCol.boundingPoly.vertices[3].x;
          secondLastColumn.words = [words[0]];
          secondLastColumn.line = words[0];

          lastColumn.id = lastColumn.id + '-1';
          lastColumn.columnIndex = lastColumn.columnIndex + 1;
          lastColumn.boundingPoly.vertices[0].x = secondLastColumn.boundingPoly.vertices[1].x;
          lastColumn.boundingPoly.vertices[3].x = secondLastColumn.boundingPoly.vertices[2].x;
          lastColumn.wordsAnnotationArray = lastColumn.wordsAnnotationArray;
          lastColumn.wordsAnnotationArray[0].description = words[1];
          lastColumn.wordsAnnotationArray[0].boundingPoly.vertices[0].x = lastColumn.boundingPoly.vertices[0].x;
          lastColumn.wordsAnnotationArray[0].boundingPoly.vertices[1].x = lastColumn.boundingPoly.vertices[0].x + (words[1].length * charWidth);
          lastColumn.wordsAnnotationArray[0].boundingPoly.vertices[2].x = lastColumn.boundingPoly.vertices[0].x+ (words[1].length * charWidth);
          lastColumn.wordsAnnotationArray[0].boundingPoly.vertices[3].x = lastColumn.boundingPoly.vertices[3].x;
          lastColumn.words = [words[1]];
          lastColumn.line = words[1];


          if (addEmptyColumn) {
            emptyColumn.boundingPoly.vertices[1].x = secondLastColumn.boundingPoly.vertices[0].x;
            emptyColumn.boundingPoly.vertices[3].x = secondLastColumn.boundingPoly.vertices[3].x;
            emptyColumn.id = emptyColumn.id + '-1:new';
            emptyColumn.wordsAnnotationArray = [];
            emptyColumn.words = [];
            emptyColumn.line = '';
            emptyColumn.columnIndex = secondLastColumn.columnIndex;
            secondLastColumn.columnIndex = secondLastColumn.columnIndex + 1;
            lastColumn.columnIndex = lastColumn.columnIndex + 1;
          }

       
          let breakAdded = false; // Flag to track if break has been added

          // Loop through transactionDetails
          for (let i = 0; i < transactionDetails.length; i++) {
              transactionDetails[i].cells.forEach((item, index) => {
                  if (!breakAdded && item.id === secondLastColumn.id) { // Check if the condition is met and break hasn't been added yet
                      if (addEmptyColumn) {
                          transactionDetails[i].cells[index] = emptyColumn;
                          let newElements = [secondLastColumn, lastColumn];
                          transactionDetails[i].cells.splice(index + 1, 0, ...newElements);
                      } else {
                          transactionDetails[i].cells[index] = secondLastColumn;
                          transactionDetails[i].cells.splice(index + 1, 0, lastColumn);
                      }
                      breakAdded = true; // Set the flag to true after adding the elements
                  }
              });
          }
        }
      }
    }
    return {
      fixApplied
    }

  }

  static alignTextToMiddle(newWordsAnnotatonArray, cellBoundingPoly) {
    // Calculate the center of the cell bounds
    const cellCenterX =
      (cellBoundingPoly.vertices[0].x + cellBoundingPoly.vertices[1].x) / 2;
    // const cellCenterY = (cellBoundingPoly.vertices[0].y + cellBoundingPoly.vertices[1].y) / 2;

    const adjustedWordsAnnotatonArray = [];

    for (let i = 0; i < newWordsAnnotatonArray.length; i++) {
      // Calculate the text bounds width and height
      const textWidth =
        newWordsAnnotatonArray[i].boundingPoly.vertices[2].x -
        newWordsAnnotatonArray[i].boundingPoly.vertices[0].x;

      // Calculate the new position for the text bounds to be middle aligned
      const newTextX = cellCenterX - textWidth / 2;

      const temp = newWordsAnnotatonArray[i];
      temp.boundingPoly.vertices[0].x = newTextX;
      temp.boundingPoly.vertices[1].x = newTextX + textWidth;
      temp.boundingPoly.vertices[2].x = newTextX + textWidth;
      temp.boundingPoly.vertices[3].x = newTextX;
      adjustedWordsAnnotatonArray.push(temp);
    }
    return adjustedWordsAnnotatonArray;
  }


  static async validateHelper(filteredTableArray, reinit, validateAllPages) {
    const errors = [];
    const autoFixes = [];
    const errPageNos = new Set();
  
    for (let i = 0; i < filteredTableArray.length - 1; i++) {
      const currentRow = filteredTableArray[i];
      const nextRow = filteredTableArray[i + 1];
  
      if (nextRow.length <= 3) continue; // Skip if next row is invalid
  
      const { balance, debitsCredits, nextBalance, added } = this.validateCalculations(currentRow, nextRow);
  
      if (isNaN(balance) || isNaN(debitsCredits) || isNaN(nextBalance)) continue; // Skip if any value is NaN
  
      let err = false;
  
      if (nextBalance !== added) {
        const res = this.addMissingDecimal(currentRow, nextRow);
        if (res.fixed) {
          autoFixes.push(res.target);
        } else {
          err = true;
          errPageNos.add(nextRow[0].pageIndex + 1);
        }
      }
  
      if (err) {
        if (!nextRow[nextRow.length - 1].line) continue; // Skip if last line doesn't exist
        if (i === filteredTableArray.length - 2 && nextBalance === 0) {
          currentRow.pageWrapping = true; // Set pageWrapping for last line
          currentRow[0].pageWrapping = true;
          continue;
        } else if (i === 0 && added === debitsCredits && balance === 0) {
          continue; // Skip if first line must wrap with previous page
        }
        if (!validateAllPages) {
          let target = nextRow[nextRow.length - 1];
          target.expected = added;
          if (reinit) await this.delay(100);
          errors.push(target);
        }
      }
    }
  
    if (validateAllPages) {
      return { autoFixes, errPageNos: Array.from(errPageNos) }; // Convert Set to Array
    } else {
      return errors;
    }
  }

  static validateCalculations (row, rowBelow) {
    // if (row.length === 5) return validateFiveColumnsAmount(row, rowBelow)

    if (!row[row.length - 1] || !rowBelow[rowBelow.length - 3] || !rowBelow[rowBelow.length - 2]) {
      return {
        balance: 0, 
        debitsCredits: 0, 
        nextBalance: 0, 
        added: 0
      }
    }
    let added: any = null;
    const balanceString = row[row.length - 1].line ? row[row.length - 1].line.replace(/[$]/g, '') : '';
    let balance = balanceString ? parseFloat(balanceString.replace(/[-] */, '-')) : 0;
    let debitsCreditsString = rowBelow[rowBelow.length - 2].line ? rowBelow[rowBelow.length - 2].line.replace(/[$]/g, '') : (rowBelow[rowBelow.length - 3].line && rowBelow.length > 4) ? rowBelow[rowBelow.length - 3].line.replace(/[$]/g, '') : '';
    let debitsCredits = debitsCreditsString ? parseFloat(debitsCreditsString.replace(/[-] */, '-')) : 0; // parseFloat("-  800.00"); // Returns: NaN
    let nextBalanceString = rowBelow[rowBelow.length - 1].line ? rowBelow[rowBelow.length - 1].line.replace(/[$]/g, '') : '';
    let nextBalance: any = nextBalanceString ? parseFloat(nextBalanceString.replace(/[-] */, '-')) : 0;

    if (!isNaN(balance) && balanceString.match(/DR/i)) balance = 0 - balance;

    if (!isNaN(balance) && !isNaN(debitsCredits)) {
      added = balance + debitsCredits;
      added = parseFloat(added.toFixed(2));
    }

    if (!isNaN(nextBalance) && nextBalanceString.match(/dr/i)) {
      nextBalance = parseFloat(nextBalance);
      nextBalance = 0 - nextBalance
    }
    nextBalance = parseFloat(nextBalance);

    return { balance, debitsCredits, nextBalance, added };
  }

  static addMissingDecimal (row, rowBelow) {
    for (let i = 2; i < rowBelow.length; i++) {
      if (rowBelow[i].line && Number.isInteger(parseFloat(rowBelow[i].line)) && rowBelow[i].wordsAnnotationArray.length === 1) {
        const modified = (parseFloat(rowBelow[i].line) / 100).toFixed(2).toString();
        const temp =  deepCopy(rowBelow);
        temp[i].line = modified;
        temp[i].wordsAnnotationArray[0].description = modified;
        temp[i].words = [modified];
        const { nextBalance, added } = this.validateCalculations(row, temp);
        if (nextBalance === added) {
          rowBelow[i].line = modified;
          rowBelow[i].wordsAnnotationArray[0].description = modified;
          rowBelow[i].words = [modified];
          return { fixed : true, target: rowBelow[i] };
        }
      }
    }

    for (let i = 2; i < row.length; i++) {
      if (row[i].line && Number.isInteger(parseFloat(row[i].line)) && row[i].wordsAnnotationArray.length === 1) {
        const modified = (parseFloat(row[i].line) / 100).toFixed(2).toString();
        const temp =  deepCopy(row);
        temp[i].line = modified;
        temp[i].wordsAnnotationArray[0].description = modified;
        temp[i].words = [modified];
        const { nextBalance, added } = this.validateCalculations(temp, rowBelow);
        if (nextBalance === added) {
          row[i].line = modified;
          row[i].wordsAnnotationArray[0].description = modified;
          row[i].words = [modified];
          return { fixed : true, target: row[i] };
        }
      }
    }

    return { fixed : false};
    
  }

  static async delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  static fixStatementsInReverseOrder (filteredTableArray, tableArrayAll) {
    let reverseTrans = false;
    // Fix - Statement dates in reverse order
    const dates = [];
    for (const item of tableArrayAll) {
      if (dates.length > 1) break;
      if (item && item.length > 0 && item[0].line) {
        if (MomentService.isValidDate(item[0].line)) {
          const standardDateFormat = MomentService.applyStandardDateFormat(item[0].line);
          // const dateObj = new Date(standardDateFormat);
          if (!dates.includes(standardDateFormat) && standardDateFormat) {
            dates.push(standardDateFormat);
          }
        }
      }
    }

    if (dates.length > 1 && dates[0] > dates[1]) {
      if (dates[0] > dates[1]) {
        console.log('reverse date for validation');
        reverseTrans = true;
        filteredTableArray = filteredTableArray.reverse();
        tableArrayAll = tableArrayAll.reverse();
      }
    }

    return {
      filteredTableArray,
      reverseTrans,
      tableArrayAll
    };
  }

  static checkEdgeRowsForGaps(filteredTableArray, wordBlocks) {
    let generalErrors = [];

    for (let i = 0; i < wordBlocks.length; i++) {
        const cellsByPage = filteredTableArray
            .filter(item => item && item[0] && item[0].pageIndex === i);

        if (cellsByPage.length > 0) {
            const smallestCell = getCellWithSmallestCoordinates(cellsByPage);

            const wordsAboveSmallestCell = wordBlocks[i].filter(item =>
                item.boundingPoly.vertices[3].y < smallestCell.boundingPoly.vertices[0].y &&
                item.boundingPoly.vertices[0].x > smallestCell.boundingPoly.vertices[0].x &&
                item.boundingPoly.vertices[1].x < smallestCell.boundingPoly.vertices[1].x
            );

            if (wordsAboveSmallestCell.length > 0) {
                const highestY = Math.max(...wordsAboveSmallestCell.map(item =>
                    item.boundingPoly.vertices[2].y
                ));

                const wordsAboveWithHighestY = wordsAboveSmallestCell.filter(item =>
                    item.boundingPoly.vertices[2].y === highestY
                );

                let joinedWords = '';

                if (wordsAboveWithHighestY.length > 0) {
                    wordsAboveSmallestCell.forEach(item => {
                        if (item.boundingPoly.vertices[0].y - 5 <= wordsAboveWithHighestY[0].boundingPoly.vertices[0].y &&
                            item.boundingPoly.vertices[2].y + 5 >= wordsAboveWithHighestY[0].boundingPoly.vertices[2].y) {
                            joinedWords = joinedWords + ' ' + item.description;
                        }
                    });
                }

                if (MomentService.isValidDate(joinedWords)) {
                    // generalErrors.push([
                    //     smallestCell.pageIndex + 1,
                    //     0,
                    //     'Check for missing top rows in the transaction.',
                    // ]);
                }
            }
        }
    }

    return generalErrors;
  }

  /**
   * Find the largest number in the arrayOfNumbers that is less than or equal to the targetNumber
   * @param {number} targetNumber - The number to compare against in order to find the largest number in arrayOfNumbers that is less than or equal to it.
   * @param {number[]} arrayOfNumbers - An array of numbers.
   * @returns {number} The largest number in arrayOfNumbers that is less than or equal to the targetNumber.
   */
  static findMaxLTE(targetNumber, arrayOfNumbers) {
    let start = arrayOfNumbers[0]; // Default to the first element

    for (let j = arrayOfNumbers.length - 1; j >= 0; j--) {
      if (targetNumber >= arrayOfNumbers[j]) {
        start = arrayOfNumbers[j];
          break;
      }
    }

    return start;
  }

}

function getCellWithSmallestCoordinates(temp) {
  let smallestCell = null;

  for (let i = 0; i < temp.length; i++) {
      const cell = temp[i][0];

      if (
          (!smallestCell ||
              cell.rowIndex < smallestCell.rowIndex ||
              (cell.rowIndex === smallestCell.rowIndex &&
                  cell.columnIndex < smallestCell.columnIndex) ||
              (cell.rowIndex === smallestCell.rowIndex &&
                  cell.columnIndex === smallestCell.columnIndex &&
                  cell.pageIndex < smallestCell.pageIndex)) &&
          cell.rowIndex !== undefined &&
          cell.columnIndex !== undefined &&
          cell.pageIndex !== undefined
      ) {
          smallestCell = cell;
      }
  }

  return smallestCell;
}

function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

/**Validate balance when tables have 5 columns (date, transaction, debit, credit, balance) */
const validateFiveColumnsAmount = (row: TextBlock[], nextRow: TextBlock[]) => {
  if (!nextRow[2] || !nextRow[3] || !row[4]) {
    return {
      balance: 0, 
      debitsCredits: 0, 
      nextBalance: 0, 
      added: 0
    }
  }
  const debit = numeral(nextRow[2].line === '' ? 0 : nextRow[2].line)
  const credit = numeral(nextRow[3].line === '' ? 0 : nextRow[3].line)
  const balance = numeral(row[4].line === '' ? 0 : row[4].line)

  let balanceValue: any = balance.value();
  if (row[4].line && row[4].line.match(/dr/i)) {
    balanceValue = 0 - balanceValue;
  }
  balanceValue = Number(balanceValue.toFixed(2));
  
  const nextBalance = numeral(nextRow[4].line === '' ? 0 : nextRow[4].line)
  let nextBalanceValue: any = nextBalance.value();
  if (nextRow[4].line && nextRow[4].line.match(/dr/i)) {
    nextBalanceValue = 0 - nextBalanceValue;
  }
  nextBalanceValue = Number(nextBalanceValue.toFixed(2));

  let debitCredit: any = Math.abs(debit.value()) ? 0 - Math.abs(debit.value()) : credit.value() ? credit.value() : 0;
  debitCredit = Number(debitCredit.toFixed(2));
  return {
    balance: balanceValue, 
    debitsCredits: debitCredit, 
    nextBalance: nextBalanceValue, 
    added: (balanceValue + debitCredit).toFixed(2)
  }
}

/**addition */
const add = (a: number, b: number) => ((a + b).toFixed(2));

/**subtraction */
const subtract = (a: number, b: number) => ((a - b).toFixed(2));